import {Auth0LinkingState} from './auth0-linking-state';

export const initialAuth0LinkingState: Auth0LinkingState = {
  isLinked: false,
  doesEmailExist: false,
  isLoading: true,
};

